import { render, staticRenderFns } from "./BCKeyAssignmentSuperLockSettings.vue?vue&type=template&id=4f851c18&scoped=true"
import script from "./BCKeyAssignmentSuperLockSettings.vue?vue&type=script&lang=js"
export * from "./BCKeyAssignmentSuperLockSettings.vue?vue&type=script&lang=js"
import style0 from "./BCKeyAssignmentSuperLockSettings.vue?vue&type=style&index=0&id=4f851c18&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f851c18",
  null
  
)

export default component.exports